/**
 * React-free drill types + constants. Imported by both the runtime UI (index) and the
 * server-grading core (core), so neither path pulls the other in.
 */

import type { FeedbackEvent } from '@usacow/engines';

/** Where a drill is being rendered. Same runner, three hosts. */
export type DrillMode = 'standalone' | 'workout-slot' | 'guided-step';

/** Props every interaction runner accepts. */
export interface DrillInteractionProps<Artifact = unknown> {
  readonly artifact: Artifact;
  readonly mode: DrillMode;
  readonly onResult: (event: FeedbackEvent) => void;
}

export type DrillKind =
  | 'deconstructor'
  | 'constraint_sniffer'
  | 'pattern_discriminator'
  | 'state_visualizer'
  | 'invariant_builder'
  | 'counterexample'
  | 'implementation_bridge'
  | 'bug_trainer';

export const DRILL_KINDS: readonly DrillKind[] = [
  'deconstructor',
  'constraint_sniffer',
  'pattern_discriminator',
  'state_visualizer',
  'invariant_builder',
  'counterexample',
  'implementation_bridge',
  'bug_trainer',
];

export const DRILL_LABEL: Record<DrillKind, string> = {
  deconstructor: 'Deconstructor',
  constraint_sniffer: 'Constraint sniffer',
  pattern_discriminator: 'Pattern discriminator',
  state_visualizer: 'State visualizer',
  invariant_builder: 'Invariant builder',
  counterexample: 'Counterexample',
  implementation_bridge: 'Implementation bridge',
  bug_trainer: 'Bug trainer',
};
